import { Component, AfterViewInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsSunburst from 'highcharts/modules/sunburst';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsSunburst(Highcharts);

import { environment } from 'src/environments/environment';
declare let $: any;

@Component({
  selector: 'app-mangmnt-dash',
  templateUrl: './mangmnt-dash.component.html',
  styleUrls: ['./mangmnt-dash.component.css']
})
export class MangmntDashComponent {

  ShowMangmntTabView: boolean = false;

  ToggleManagement(boolean: boolean) {
    this.ShowMangmntTabView = boolean;
  }


  ShowKmsTabView: boolean = false;

  ToggleKms(boolean: boolean) {
    this.ShowKmsTabView = boolean;
  }


  ShowRmsTabView: boolean = false;

  ToggleRms(boolean: boolean) {
    this.ShowRmsTabView = boolean;
  }

  ShowFciTabView: boolean = false;

  ToggleFci(boolean: boolean) {
    this.ShowFciTabView = boolean;
  }

  ShowAgencyTabView: boolean = false;

  ToggleAgency(boolean: boolean) {
    this.ShowAgencyTabView = boolean;
  }

  ShowTotalTabView: boolean = false;

  ToggleTotal(boolean: boolean) {
    this.ShowTotalTabView = boolean;
  }

  ShowMovementTabView: boolean = false;

  ToggleMovement(boolean: boolean) {
    this.ShowMovementTabView = boolean;
  }

  ShowReferenceTabView: boolean = false;

  ToggleReference(boolean: boolean) {
    this.ShowReferenceTabView = boolean;
  }

  ShowPublicTabView: boolean = false;

  TogglePublic(boolean: boolean) {
    this.ShowPublicTabView = boolean;
  }



  public ngAfterViewInit(): void {
    this.createChartColumn();
    this.createChartColumn1();
    this.createChartColumn2();
    this.createChartColumn3();
    // this.createChartColumn4();
    this.createChartColumn5();
    this.createChartColumn6();
    this.createChartColumn7();
    this.createChartColumn8();
    this.createChartColumn9();
  }
  private getRandomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }


  constructor() { }

  setTheme(themeName: any) {
    localStorage.setItem('theme', themeName);
    document.documentElement.className = `${themeName}  english-font`;
  }

  ngOnInit(): void {
    this.setTheme('theme-light');
  }

  // allocation start
  private createChartColumn(): void {
    const chart = Highcharts.chart('allocation-column' as any, {
      chart: {
        type: 'column',
        height: 295,
        backgroundColor: '#fff'

      },
      title: {
        text: ''
      },

      credits: {
        enabled: false
      },

      xAxis: {
        gridLineWidth: 0,
        gridLineColor: '#dee2e6',
        type: 'category',
        lineColor: '#dee2e6',
        labels: {
          style: {
            color: '#626262'
          }
        }
      },
      yAxis: {

        lineWidth: 0,
        lineColor: '#dee2e6',
        gridLineColor: '#dee2e6',
        title: {
          text: '',
          style: {
            color: '#626262'
          }
        },
        labels: {
          enabled: false,
          style: {
            color: '#626262'
          }
        }

      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          pointWidth: 18,
          borderRadius: 4,
          dataLabels: {
            color: '#626262',
            enabled: true,
            format: '{point.y:10f}'
          }
        }
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>'

      },

      series: [
        {
          name: "Statistics",
          colorByPoint: true,
          data: [
            {
              name: "Allocation",
              y: 4676130,
              color: '#06341a'
            },
            {
              name: "Day's Offtake",
              y: 146014,
              color: '#215035'
            },
            {
              name: "Progressive Offtake",
              y: 3195018,
              color: '#da7701'
            },
            {
              name: "% Offtake",
              y: 68.33,
              color: '#1e754d'
            },
            {
              name: "Lifting",
              y: 300663,
              color: '#f26727'
            },
            {
              name: "Progressive Lifting",
              y: 565944,
              color: '#53d28d'
            },

          ]
        }
      ],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            plotOptions: {
              column: {
                pointWidth: 20,
                stacking: 'normal'
              }
            }
          }
        }]
      },
    } as any);

  }

  // kms column start
  private createChartColumn1(): void {

    const chart = Highcharts.chart('kms-column' as any, {
      chart: {
        type: 'line',
        height: 295,
        backgroundColor: '#fff'

      },
      title: {
        text: ''
      },

      credits: {
        enabled: false
      },

      xAxis: {
        gridLineWidth: 0,
        gridLineColor: '#dee2e6',
        type: 'category',
        lineColor: '#dee2e6',
        title: {
          text: '',
          style: {
            color: '#626262'
          }
        },
        labels: {
          style: {
            color: '#626262'
          }
        }
      },
      yAxis: {

        lineWidth: 0,
        lineColor: '#dee2e6',
        gridLineColor: '#dee2e6',
        title: {
          text: '',
          style: {
            color: '#626262'
          }
        },
        labels: {
          enabled: false,
          style: {
            color: '#626262'
          }
        }

      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          pointWidth: 18,
          borderRadius: 4,
          dataLabels: {
            color: '#626262',
            enabled: true,
            format: '{point.y:10f}'
          }
        }
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>'

      },

      series: [
        {
          name: "Statistics",
          colorByPoint: true,
          data: [
            {
              name: "Procurement",
              y: 15445846,
              color: '#53d28d'
            },
            {
              name: "Corresponding Proc. last Year",
              y: 17027002,
              color: '#53d28d'
            },
            {
              name: "Farmers Benefitted",
              y: 895466,
              color: '#53d28d'
            },
          ]
        }
      ],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            plotOptions: {
              column: {
                pointWidth: 20,
                stacking: 'normal'
              }
            }
          }
        }]
      },
    } as any);

  }

  
  // Agency Chart
  private createChartColumn5(): void {

    const chart = Highcharts.chart('agency-column' as any, {
      chart: {
        type: 'column',
        height: 295,
        backgroundColor: '#fff'

      },

      title: {
        text: '',
        align: 'left'
      },

      credits: {
        enabled: false
      },

      subtitle: {
        text: '',
        align: 'left'
      },

      yAxis: {
        labels: {
          enabled : false
        },
        title: {
          text: ''
        },
        pointStart: 2010,
      },

      xAxis: {
        categories: [
          'Covered',
          'Scientific CAP',
          'Silo',
        ],
      },

      legend: {
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}"></span> <b>{point.y:10f}</b><br/>'

    },

      plotOptions: {
        series: {
          pointWidth: 18,
          borderRadius: 4,
          dataLabels: {
            color: '#626262',
            enabled: true,
            format: '{point.y:10f}'
          }
        }
      },

      series: [{
        name: 'Capacity',
        data: [35558844, 0, 1335000],
        y: 75.11,
        color: '#006637'
      }, {
        name: 'Stock',
        data: [26707870, 0, 1116863],
          y: 0.00,
          color: '#da7701'
      }, {
        name: '% Utilization',
        data: [75.11, 0, 83.66],
          y: 83.66,
          color: '#F26727'
      }
    ],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    } as any);

  }

  // total column start
  private createChartColumn9(): void {

    const chart = Highcharts.chart('total-column' as any, {
      chart: {
        type: 'column',
        height: 295,
        backgroundColor: '#fff'

      },

      title: {
        text: '',
        align: 'left'
      },

      credits: {
        enabled: false
      },

      subtitle: {
        text: '',
        align: 'left'
      },

      yAxis: {
        labels:{
          enabled: false
        },
        title: {
          text: ''
        },
        pointStart: 2010,
      },

      xAxis: {
        categories: [
          'Covered',
          'Scientific CAP',
          'Silo',
        ],
      },

      legend: {
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}"></span> <b>{point.y:10f}</b><br/>'

    },

      plotOptions: {
        series: {
          pointWidth: 18,
          borderRadius: 4,
          dataLabels: {
            color: '#626262',
            enabled: true,
            format: '{point.y:10f}'
          }
        }
      },

      series: [{
        name: 'Capacity',
        data: [73223738, 0, 1335000],
        y: 75.11,
        color: '#006637'
      }, {
        name: 'Stock',
        data: [40326302, 0, 1116863],
          y: 0.00,
          color: '#da7701'
      }, {
        name: '% Utilization',
        data: [55.07, 0, 83.66],
          y: 83.66,
          color: '#F26727'
      }
    ],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    } as any);

  }

  
  // reference column start

  private createChartColumn7(): void {

    const chart = Highcharts.chart('reference-column' as any, {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
    },
    title: {
        text: '',
        align: 'left'
    },
    credits: {
      enabled: false
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.y:f}</b>'
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: false
            },
            showInLegend: true
        }
    },
    series: [{
        name: 'Statistics',
        colorByPoint: true,
        data: [{
            name: 'Upto 1 month',
            y: 18,
            sliced: true,
            selected: true,
            color : '#06341a'
        },  {
            name: '1 to 3 months',
            y: 40,
            color : '#006637'
        },  {
            name: '3 to 6 months',
            y: 50,
            color : '#da7701'
        }, {
            name: 'More than 6 months',
            y: 20,
            color : '#f26727'
        }]
    }]

  } as any);

  }


  // fci column start
  private createChartColumn3(): void {

    const chart = Highcharts.chart('fci-column' as any, {
      chart: {
        type: 'column',
        height: 295,
        backgroundColor: '#fff'

      },

      title: {
        text: '',
        align: 'left'
      },

      credits: {
        enabled: false
      },

      subtitle: {
        text: '',
        align: 'left'
      },

      yAxis: {
        labels: {
          enabled : false
        },
        title: {
          text: ''
        },
        pointStart: 2010,
      },

      xAxis: {
        categories: [
          'Covered',
          'Scientific CAP',
          'Silo',
        ],
      },

      legend: {
        // layout: 'vertical',
        // align: 'bottom',
        // verticalAlign: 'middle'
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}"></span> <b>{point.y:10f}</b><br/>'

    },

      plotOptions: {
        series: {
          pointWidth: 18,
          borderRadius: 4,
          dataLabels: {
            color: '#626262',
            enabled: true,
            format: '{point.y:10f}'
          }
        }
      },

      series: [{
        name: 'Capacity',
        data: [35558844, 0, 1335000],
        y: 75.11,
        color: '#006637'
      }, {
        name: 'Stock',
        data: [26707870, 0, 1116863],
          y: 0.00,
          color: '#da7701'
      }, {
        name: '% Utilization',
        data: [75.11, 0, 83.66],
          y: 83.66,
          color: '#F26727'
      }
    ],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    } as any);

  }


// rms column start
  private createChartColumn2(): void {

    const chart = Highcharts.chart('rms-column' as any, {
      chart: {
        type: 'line',
        height: 295,
        backgroundColor: '#fff'

      },
      title: {
        text: ''
      },

      credits: {
        enabled: false
      },

      xAxis: {
        gridLineWidth: 0,
        gridLineColor: '#dee2e6',
        type: 'category',
        lineColor: '#dee2e6',
        title: {
          text: '',
          style: {
            color: '#626262'
          }
        },
        labels: {
          style: {
            color: '#626262'
          }
        }
      },
      yAxis: {

        lineWidth: 0,
        lineColor: '#dee2e6',
        gridLineColor: '#dee2e6',
        title: {
          text: '',
          style: {
            color: '#626262'
          }
        },
        labels: {
          enabled: false,
          style: {
            color: '#626262'
          }
        }

      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          pointWidth: 18,
          borderRadius: 4,
          dataLabels: {
            color: '#626262',
            enabled: true,
            format: '{point.y:10f}'
          }
        }
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>'

      },

      series: [
        {
          name: "Statistics",
          colorByPoint: true,
          data: [
            {
              name: "Procurement",
              y: 26202224,
              color: '#53d28d'
            },
            {
              name: "Corresponding Proc. last Year",
              y: 18632883,
              color: '#53d28d'
            },
            {
              name: "Farmers Benefitted",
              y: 2128985,
              color: '#53d28d'
            },
          ]
        }
      ],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            plotOptions: {
              column: {
                pointWidth: 20,
                stacking: 'normal'
              }
            }
          }
        }]
      },
    } as any);

  }

  // public column start
  private createChartColumn8(): void {

    const chart = Highcharts.chart('public-column' as any, {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
    },
    title: {
        text: '',
        align: 'left'
    },
    credits: {
      enabled: false
    },
    tooltip: {
        pointFormat: '{series.name}: <b>{point.y:f}</b>'
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: false
            },
            showInLegend: true
        }
    },
    series: [{
        name: 'Statistics',
        colorByPoint: true,
        data: [{
            name: 'Upto 1 month',
            y: 18,
            sliced: true,
            selected: true,
            color : '#06341a'
        },  {
            name: '1 to 3 months',
            y: 40,
            color : '#006637'
        },  {
            name: '3 to 6 months',
            y: 50,
            color : '#da7701'
        }, {
            name: 'More than 6 months',
            y: 20,
            color : '#f26727'
        }]
    }]

  } as any);

  }

  // movement-column

  private createChartColumn6(): void {

    const chart = Highcharts.chart('movement-column' as any, {
      chart: {
        type: 'column',
        height: 295,
        backgroundColor: '#fff'

      },

      title: {
        text: '',
        align: 'left'
      },

      credits: {
        enabled: false
      },

      subtitle: {
        text: '',
        align: 'left'
      },

      yAxis: {
        labels: {
          enabled: false
        },
        title: {
          text: ''
        },
        pointStart: 2010,
      },

      xAxis: {
        // accessibility: {
        //   rangeDescription: 'Range: 2010 to 2020'
        // }
        categories: [
          'Planned',
          'Dispatched',
          'Percentage',
        ],
      },

      legend: {
        // layout: 'vertical',
        // align: 'bottom',
        // verticalAlign: 'middle'
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat: '<span style="color:{point.color}"></span> <b>{point.y:10f}</b><br/>'

    },

      plotOptions: {
        series: {
          pointWidth: 18,
          borderRadius: 4,
          dataLabels: {
            color: '#626262',
            enabled: true,
            format: '{point.y:10f}'
          }
        }
      },

      series: [{
        name: 'Rakes',
        data: [0, 18, 0],
        y: 75.11,
        color: '#006637'
      }, {
        name: 'Quantity (MT)',
        data: [0, 53.50, 0],
          y: 0.00,
          color: '#f26727'
      }
    ],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }

    } as any);

  }



}
